
import 'quasar/dist/quasar.css'
import lang from 'quasar/lang/es.js'
import '@quasar/extras/roboto-font/roboto-font.css'
import '@quasar/extras/material-icons/material-icons.css'
import './css/app.css'
import Notify from 'quasar/src/plugins/Notify.js';import Loading from 'quasar/src/plugins/Loading.js';import LocalStorage from 'quasar/src/plugins/LocalStorage.js';

// To be used on app.use(Quasar, { ... })
export default {
  config: {
    notify: {
      timeout: 1000,
      position: 'bottom'
    },
    loading: {
      message: 'Cargando... Espere por favor'
    },
    brand: {
      pragma_pri: '#a53042'
    }
  },
  plugins: {
    Notify,
    Loading,
    LocalStorage
  },
  lang: lang,
  framework: {
    config: {
      cordova: {
        // Quasar handles app exit on mobile phone back button.
        backButtonExit: true,

        // On the other hand, the following completely
        // disables Quasar's back button management.
        backButton: true
      },
      capacitor: {
        // Quasar handles app exit on mobile phone back button.
        backButtonExit: true,

        // On the other hand, the following completely
        // disables Quasar's back button management.
        backButton: true
      }
    }
  }
}